import { Component, OnInit } from '@angular/core';
import { MdDialogRef } from '@angular/material';

@Component({
  selector: 'app-text-area-dialog',
  templateUrl: './text-area-dialog.component.html',
  styleUrls: ['./text-area-dialog.component.scss']
})
export class TextAreaDialogComponent implements OnInit {

  public title: string;
  public positiveText: string;
  public negativeText: string;
  public text: string;
  public requieredComment = false;
  private saveEnabled: boolean = true;
  public textMaxLength: number;

  constructor(public dialogRef: MdDialogRef<TextAreaDialogComponent>) { }

  ngOnInit() {
    if (this.requieredComment) {
      this.saveEnabled = false;
    }
  }

  checkTextLength() {
    if (this.requieredComment) {
      this.saveEnabled = this.text.trim().length > 0;
    }
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/dialog/text-area-dialog/text-area-dialog.component.ts